import type { Routes } from '@angular/router';
import { authRoutes } from './features/auth/auth.routes.js';
import { authGuard } from './core/auth/auth.guard.js';

export const routes: Routes = [
  // Public
  ...authRoutes,
  // Authenticated shell
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./shell/shell.component.js').then((m) => m.ShellComponent),
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component.js').then((m) => m.DashboardComponent),
      },
    ],
  },
  { path: '**', redirectTo: '/' },
];
